<template>
  <div :class="container">
    <div class="pagetitle"><H3 class="title" style="text-indent: 0;text-align:center;">联系我们</H3></div>
    <h4 style="text-indent: 0;">
      江苏和悦医疗科技有限公司
    </h4>
    <p style="font-size:16px;text-indent: 0;min-height:280px;">
地址：盐城市响水县响水镇农民创业园7#厂房（东海路西侧）<br>
公司电话：0515-86621986	<br>
传真：0515-86621986<br>
联系人：李先生 18912598422
    </p>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      container: "container",
    };
  },
};
</script>

<style type="css">
.container {
  max-width: 1200px;
  text-align: left;
  margin:0 auto;
  line-height: 200%;
  text-indent: 2em;
  font-size: 19px;;
}
</style>